const currentURL = window.location.href;

if (currentURL.indexOf('.dbkdev.nl') > -1) {
    $('html').addClass('env-dbkdev');
} else if (currentURL.indexOf('localhost') > -1 || currentURL.indexOf('.test') > -1) {
    $('html').addClass('env-local');
}
